module.exports = __webpack_public_path__ + "img/03：Modena.9188a886.jpg";